(function($){
	
	const
	header = $('.site-header'),
	switcher = $('.js-wpml-ls-item-toggle'),
	switcher_menu = $('.wpml-ls-sub-menu');
	
	switcher.on('click', function(){
		add_active_class()
	}) 

	//when we lose focus of dropdown remove class
	switcher.on('blur', function() {
		$(this).removeClass('wpml-ls-item-toggle--is-active')
	})
	
	function add_active_class() {
		//we just need to toggle here
		switcher.toggleClass("wpml-ls-item-toggle--is-active");
	}
	
	$(document).scroll(function() {
		if ( header.hasClass('site-header--is-admin') && $(document ).scrollTop() > 46 ) {
			header.addClass('site-header--top');
		} else {
			header.removeClass('site-header--top');
		}
	});

	$('.wpml-ls-sub-menu').each(function() {
		var len = $(this).find("li").length == 0
		if (len) 
			$('.widget_icl_lang_sel_widget').css('display', 'none');
	})
	
})(jQuery);